import {StatesItemType} from 'types/locationType';

import {
    AddressElementType,
    AssociationType,
} from '../../../decomposeAllAddressesByComponents/utils/applyAssociations/applyAssociationsTypes';

type ModifierType = (association: Partial<AssociationType>) => AddressElementType | null;

/**
 * Configures and returns modifier for region code field
 * @param {Array<StatesItemType>} states - States to search
 * @return {ModifierType} - Configured modifier for region code field
 */
export const getRegionCodeModifier =
    (states: Array<StatesItemType>): ModifierType =>
    ({value}: Partial<AssociationType>): AddressElementType | null => {
        if (states.length > 0) {
            const suitableState = states.find((state: StatesItemType) => state.value === value);
            return {
                value: suitableState ? suitableState.id : '',
            };
        }
        return null;
    };
